import { format } from 'date-fns';
import React from 'react';

function PrintHeader({ headerFooterInfo }) {
  const formattedTime = format(new Date(), 'MM-dd-yyyy');
  return (
    <>
      <table
        id="header"
        width="734px"
        align="left"
        valign="top"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ fontSize: 14, marginBottom: 20 }}
      >
        <thead>
          <tr width="734px">
            <th
              align="left"
              width="450px"
              style={{ borderBottom: '1px solid #333' }}
            >
              <img
                src={headerFooterInfo?.header?.headerImage}
                width="280px;"
                height="76px"
                alt=""
              />
            </th>
            <th
              align="right"
              width="284px"
              style={{
                fontSize: 21,
                color: '#000',
                borderBottom: '1px solid #333',
              }}
            >
              <table
                width="284px"
                align="left"
                valign="top"
                border={0}
                cellSpacing={0}
                cellPadding={0}
              >
                <tbody>
                  <tr width="284px">
                    <td
                      align="left"
                      width="334px"
                      style={{
                        fontSize: 15,
                        color: '#000',
                        fontWeight: 'bold',
                      }}
                    >
                      {/* {headerFooterInfo?.header?.clinicName} */}
                    </td>
                  </tr>
                  <tr width="284px">
                    <td
                      align="left"
                      width="334px"
                      style={{
                        fontSize: 15,
                        color: '#000',
                        fontWeight: 'bold',
                      }}
                    >
                      {headerFooterInfo?.header?.providerName}
                      <br />
                      {headerFooterInfo?.header?.counsellorName}
                    </td>
                  </tr>
                  <tr width="284px">
                    <td
                      align="left"
                      width="334px"
                      style={{
                        fontSize: 12,
                        color: '#000',
                        fontWeight: 'lighter',
                        paddingTop: 5,
                      }}
                    >
                      {headerFooterInfo?.header?.address}
                    </td>
                  </tr>
                  <tr width="284px">
                    <td
                      align="left"
                      width="334px"
                      style={{
                        fontSize: 12,
                        color: '#000',
                        fontWeight: 'lighter',
                      }}
                    >
                      <b>PH:</b> {headerFooterInfo?.header?.phone}, <b>Fax:</b>{' '}
                    </td>
                  </tr>
                  <tr width="284px">
                    <td
                      align="left"
                      width="334px"
                      style={{
                        fontSize: 12,
                        color: '#000',
                        fontWeight: 'lighter',
                      }}
                    >
                      {headerFooterInfo?.header?.email}
                    </td>
                  </tr>
                </tbody>
              </table>
            </th>
          </tr>
          <tr width="734px">
            <td
              colSpan={2}
              align="right"
              width="734px"
              style={{ fontSize: 14, color: '#000', paddingTop: 10 }}
            >
              Date: {formattedTime}
            </td>
          </tr>
        </thead>
      </table>
    </>
  );
}

export default PrintHeader;
